export enum INVITATION_ERROR_TYPE {
    INVITATION_INVALID = 'INVITATION_INVALID',
    INVITATION_UNSUPPORTED = 'INVITATION_UNSUPPORTED',
    INVALID_METHOD = 'INVALID_METHOD',
    NO_COMPONENT = 'NO_COMPONENT',
    NO_VEVENT = 'NO_VEVENT',
    PARSING_ERROR = 'PARSING_ERROR',
    DECRYPTION_ERROR = 'DECRYPTION_ERROR',
    FETCHING_ERROR = 'FETCHING_ERROR',
    UPDATING_ERROR = 'UPDATING_ERROR',
    EVENT_CREATION_ERROR = 'EVENT_CREATION_ERROR',
    EVENT_UPDATE_ERROR = 'EVENT_UPDATE_ERROR',
    CANCELLATION_ERROR = 'CANCELLATION_ERROR',
    UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
    EXTERNAL_ERROR = 'EXTERNAL_ERROR',
}

export enum EVENT_INVITATION_ERROR_TYPE {
    NON_GREGORIAN = 'NON_GREGORIAN',
    INVALID_METHOD = 'INVALID_METHOD',
    NO_VEVENT = 'NO_VEVENT',
    MISSING_ORIGINAL_UID = 'MISSING_ORIGINAL_UID',
    MISSING_ORGANIZER = 'MISSING_ORGANIZER',
    MISSING_ORIGINAL_ORGANIZER = 'MISSING_ORIGINAL_ORGANIZER',
    MISSING_ATTENDEE = 'MISSING_ATTENDEE',
    DUPLICATE_ATTENDEES = 'DUPLICATE_ATTENDEES',
    UNEXPECTED_FLOATING_TIME = 'UNEXPECTED_FLOATING_TIME',
    X_WR_TIMEZONE_UNSUPPORTED = 'X_WR_TIMEZONE_UNSUPPORTED',
    TZID_UNSUPPORTED = 'TZID_UNSUPPORTED',
    DTSTART_MISSING = 'DTSTART_MISSING',
    ALLDAY_INCONSISTENCY = 'ALLDAY_INCONSISTENCY',
    DTSTART_MALFORMED = 'DTSTART_MALFORMED',
    DTSTART_OUT_OF_BOUNDS = 'DTSTART_OUT_OF_BOUNDS',
    DTEND_MALFORMED = 'DTEND_MALFORMED',
    DTEND_OUT_OF_BOUNDS = 'DTEND_OUT_OF_BOUNDS',
    RRULE_MALFORMED = 'RRULE_MALFORMED',
    RRULE_UNSUPPORTED = 'RRULE_UNSUPPORTED',
    SINGLE_EDIT_UNSUPPORTED = 'SINGLE_EDIT_UNSUPPORTED',
    NO_OCCURRENCES = 'NO_OCCURRENCES',
    EXTERNAL_ERROR = 'EXTERNAL_ERROR',
    VALIDATION_ERROR = 'VALIDATION_ERROR',
}

export enum IMPORT_EVENT_ERROR_TYPE {
    WRONG_FORMAT = 'WRONG_FORMAT',
    NON_GREGORIAN = 'NON_GREGORIAN',
    TODO_FORMAT = 'TODO_FORMAT',
    JOURNAL_FORMAT = 'JOURNAL_FORMAT',
    FREEBUSY_FORMAT = 'FREEBUSY_FORMAT',
    TIMEZONE_FORMAT = 'TIMEZONE_FORMAT',
    TIMEZONE_IGNORE = 'TIMEZONE_IGNORE',
    VEVENT_INVALID = 'VEVENT_INVALID',
    VEVENT_UNSUPPORTED = 'VEVENT_UNSUPPORTED',
    UNEXPECTED_FLOATING_TIME = 'UNEXPECTED_FLOATING_TIME',
    ALLDAY_INCONSISTENCY = 'ALLDAY_INCONSISTENCY',
    DTSTART_MISSING = 'DTSTART_MISSING',
    DTSTART_MALFORMED = 'DTSTART_MALFORMED',
    DTSTART_OUT_OF_BOUNDS = 'DTSTART_OUT_OF_BOUNDS',
    DTEND_MALFORMED = 'DTEND_MALFORMED',
    DTEND_OUT_OF_BOUNDS = 'DTEND_OUT_OF_BOUNDS',
    X_WR_TIMEZONE_UNSUPPORTED = 'X_WR_TIMEZONE_UNSUPPORTED',
    TZID_UNSUPPORTED = 'TZID_UNSUPPORTED',
    RRULE_MALFORMED = 'RRULE_MALFORMED',
    RRULE_UNSUPPORTED = 'RRULE_UNSUPPORTED',
    SINGLE_EDIT_UNSUPPORTED = 'SINGLE_EDIT_UNSUPPORTED',
    NOTIFICATION_OUT_OF_BOUNDS = 'NOTIFICATION_OUT_OF_BOUNDS',
    VALIDATION_ERROR = 'VALIDATION_ERROR',
    ENCRYPTION_ERROR = 'ENCRYPTION_ERROR',
    PARENT_EVENT_MISSING = 'PARENT_EVENT_MISSING',
    EXTERNAL_ERROR = 'EXTERNAL_ERROR',
    NO_OCCURRENCES = 'NO_OCCURRENCES',
}
